var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWasabi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 195,
    height: 195.01,
    viewBox: "0 0 195 195.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00ce3e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.79,31.5a97.51,97.51,0,1,0,25.4,94.27,97.5,97.5,0,0,0-25.4-94.27Zm10.54,60.08-42-38.1L314.42,94.06l-22.58,21.21V83.65L326,51.15,351.58,27a80.18,80.18,0,0,1,47.76,64.55Zm-.75,23a79.31,79.31,0,0,1-8.4,23.94l-23.91-21.81V85.09Zm-66.51-93.2L314,38.45,291.78,59.54v-34a80.15,80.15,0,0,1,40.32-4.17Zm-57.78,94.47L241.15,86.1a79.34,79.34,0,0,1,8.71-24.33L274.29,83.7Zm0-81.09V60.09L260.06,47.33A79.9,79.9,0,0,1,274.29,34.7Zm-34,74.08,42.95,38.51,65.46-61.61v31.07l-60.37,57.12a80.14,80.14,0,0,1-48-65.1Zm67.56,70.7,40.87-38.64V175a79.53,79.53,0,0,1-28.86,5.39,82.13,82.13,0,0,1-12-.89Zm58.38-13.93V140.34L380.18,153a78.58,78.58,0,0,1-13.9,12.64Z",
    transform: "translate(-222.5 -3.09)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasabi);
export default __webpack_public_path__ + "static/media/wasabi.f40385f62144882ff8e21519036b1cba.svg";
export { ForwardRef as ReactComponent };